module.exports = __webpack_public_path__ + "img/consult_info2.1f4475a3.png";